class FlagsService {
    constructor() {
        this.flagsEmojiMappings = {
            "United Arab Emirates": "🇦🇪",
            "Afghanistan": "🇦🇫",
            "Alaska": "🇺🇸",
            "Antigua and Barbuda": "🇦🇬",
            "Anguilla": "🇦🇮",
            "Albania": "🇦🇱",
            "Armenia": "🇦🇲",
            "Angola": "🇦🇴",
            "Argentina": "🇦🇷",
            "Australia": "🇦🇺",
            "Austria": "🇦🇹",
            "Algeria": "🇩🇿",
            "Azerbaijan": "🇦🇿",
            "Bahamas": "🇧🇸",
            "Bahrain": "🇧🇭",
            "Bangladesh": "🇧🇩",
            "Barbados": "🇧🇧",
            "Belarus": "🇧🇾",
            "Belgium": "🇧🇪",
            "Belize": "🇧🇿",
            "Benin": "🇧🇯",
            "Bhutan": "🇧🇹",
            "Bolivia": "🇧🇴",
            "Bosnia and Herzegovina": "🇧🇦",
            "Botswana": "🇧🇼",
            "Brazil": "🇧🇷",
            "Brunei": "🇧🇳",
            "Bulgaria": "🇧🇬",
            "Burkina Faso": "🇧🇫",
            "Burundi": "🇧🇮",
            "Cabo Verde": "🇨🇻",
            "Cambodia": "🇰🇭",
            "Cameroon": "🇨🇲",
            "Canada": "🇨🇦",
            "Central African Republic": "🇨🇫",
            "Chad": "🇹🇩",
            "Chile": "🇨🇱",
            "China": "🇨🇳",
            "Colombia": "🇨🇴",
            "Congo (Congo-Brazzaville)": "🇨🇬",
            "Congo (Democratic Republic)": "🇨🇩",
            "Costa Rica": "🇨🇷",
            "Cote d'Ivoire": "🇨🇮",
            "Croatia": "🇭🇷",
            "Cuba": "🇨🇺",
            "Cyprus": "🇨🇾",
            "Czechia (Czech Republic)": "🇨🇿",
            "Denmark": "🇩🇰",
            "Djibouti": "🇩🇯",
            "Dominica": "🇩🇲",
            "Dominican Republic": "🇩🇴",
            "Ecuador": "🇪🇨",
            "Egypt": "🇪🇬",
            "El Salvador": "🇸🇻",
            "Equatorial Guinea": "🇬🇶",
            "Eritrea": "🇪🇷",
            "Estonia": "🇪🇪",
            "Eswatini (fmr. Swaziland)": "🇸🇿",
            "Ethiopia": "🇪🇹",
            "Fiji": "🇫🇯",
            "Finland": "🇫🇮",
            "France": "🇫🇷",
            "Gabon": "🇬🇦",
            "Gambia": "🇬🇲",
            "Georgia": "🇬🇪",
            "Germany": "🇩🇪",
            "Ghana": "🇬🇭",
            "Greece": "🇬🇷",
            "Grenada": "🇬🇩",
            "Guatemala": "🇬🇹",
            "Guinea": "🇬🇳",
            "Guinea-Bissau": "🇬🇼",
            "Guyana": "🇬🇾",
            "Haiti": "🇭🇹",
            "Honduras": "🇭🇳",
            "Hungary": "🇭🇺",
            "Iceland": "🇮🇸",
            "India": "🇮🇳",
            "Indonesia": "🇮🇩",
            "Iran": "🇮🇷",
            "Iraq": "🇮🇶",
            "Ireland": "🇮🇪",
            "Israel": "🇮🇱",
            "Italy": "🇮🇹",
            "Jamaica": "🇯🇲",
            "Japan": "🇯🇵",
            "Jordan": "🇯🇴",
            "Kazakhstan": "🇰🇿",
            "Kenya": "🇰🇪",
            "Kiribati": "🇰🇮",
            "North Korea": "🇰🇵",
            "South Korea": "🇰🇷",
            "Kuwait": "🇰🇼",
            "Kyrgyzstan": "🇰🇬",
            "Laos": "🇱🇦",
            "Latvia": "🇱🇻",
            "Lebanon": "🇱🇧",
            "Lesotho": "🇱🇸",
            "Liberia": "🇱🇷",
            "Libya": "🇱🇾",
            "Liechtenstein": "🇱🇮",
            "Lithuania": "🇱🇹",
            "Luxembourg": "🇱🇺",
            "Madagascar": "🇲🇬",
            "Malawi": "🇲🇼",
            "Malaysia": "🇲🇾",
            "Maldives": "🇲🇻",
            "Mali": "🇲🇱",
            "Malta": "🇲🇹",
            "Marshall Islands": "🇲🇭",
            "Mauritania": "🇲🇷",
            "Mauritius": "🇲🇺",
            "Mexico": "🇲🇽",
            "Micronesia (Federated States)": "🇫🇲",
            "Moldova": "🇲🇩",
            "Monaco": "🇲🇨",
            "Mongolia": "🇲🇳",
            "Montenegro": "🇲🇪",
            "Morocco": "🇲🇦",
            "Mozambique": "🇲🇿",
            "Myanmar (formerly Burma)": "🇲🇲",
            "Namibia": "🇳🇦",
            "Nauru": "🇳🇷",
            "Nepal": "🇳🇵",
            "Netherlands": "🇳🇱",
            "New Zealand": "🇳🇿",
            "Nicaragua": "🇳🇮",
            "Niger": "🇳🇪",
            "Nigeria": "🇳🇬",
            "North Macedonia": "🇲🇰",
            "Norway": "🇳🇴",
            "Oman": "🇴🇲",
            "Pakistan": "🇵🇰",
            "Palau": "🇵🇼",
            "Panama": "🇵🇦",
            "Papua New Guinea": "🇵🇬",
            "Paraguay": "🇵🇾",
            "Peru": "🇵🇪",
            "Philippines": "🇵🇭",
            "Poland": "🇵🇱",
            "Portugal": "🇵🇹",
            "Qatar": "🇶🇦",
            "Romania": "🇷🇴",
            "Russia": "🇷🇺",
            "Rwanda": "🇷🇼",
            "Saint Kitts and Nevis": "🇰🇳",
            "Saint Lucia": "🇱🇨",
            "Saint Vincent and the Grenadines": "🇻🇨",
            "Samoa": "🇼🇸",
            "San Marino": "🇸🇲",
            "Sao Tome and Principe": "🇸🇹",
            "Saudi Arabia": "🇸🇦",
            "Senegal": "🇸🇳",
            "Serbia": "🇷🇸",
            "Seychelles": "🇸🇨",
            "Sierra Leone": "🇸🇱",
            "Singapore": "🇸🇬",
            "Slovakia": "🇸🇰",
            "Slovenia": "🇸🇮",
            "Solomon Islands": "🇸🇧",
            "Somalia": "🇸🇴",
            "South Africa": "🇿🇦",
            "South Sudan": "🇸🇸",
            "Spain": "🇪🇸",
            "Sri Lanka": "🇱🇰",
            "Sudan": "🇸🇩",
            "Suriname": "🇸🇷",
            "Sweden": "🇸🇪",
            "Switzerland": "🇨🇭",
            "Syria": "🇸🇾",
            "Taiwan": "🇹🇼",
            "Tajikistan": "🇹🇯",
            "Tanzania": "🇹🇿",
            "Thailand": "🇹🇭",
            "Timor-Leste": "🇹🇱",
            "Togo": "🇹🇬",
            "Tonga": "🇹🇴",
            "Trinidad and Tobago": "🇹🇹",
            "Tunisia": "🇹🇳",
            "Turkey": "🇹🇷",
            "Turkmenistan": "🇹🇲",
            "Tuvalu": "🇹🇻",
            "Uganda": "🇺🇬",
            "Ukraine": "🇺🇦",
            "United Kingdom": "🇬🇧",
            "United States": "🇺🇸",
            "Uruguay": "🇺🇾",
            "Uzbekistan": "🇺🇿",
            "Vanuatu": "🇻🇺",
            "Venezuela": "🇻🇪",
            "Vietnam": "🇻🇳",
            "Yemen": "🇾🇪",
            "Zambia": "🇿🇲",
            "Zimbabwe": "🇿🇼",

            "Buzz Lightyear": "🚀",
            "Woody": "🤠",
            "Nemo": "🐟",
            "Wall-E": "🤖",
            "EVE": "🌌",
            "Joy": "😊",
            "Sadness": "😢",
            "Mickey Mouse": "🐭",
            "Minnie Mouse": "🎀",
            "Aladdin": "🕌",
            "Jasmine": "🌸",
            "Moana": "🌊",
            "Elsa": "❄️",
            "Anna": "🌷",
            "Olaf": "⛄",
            "Belle": "📚",
            "Ariel": "🧜‍♀️",
            "Donald Duck": "🦆",
            "Goofy": "🎩",
            "Peter Pan": "🧚",
            "Tinker Bell": "✨",
            "Cinderella": "👠",
            "Snow White": "🍎",
            "Aurora": "💤",
            "Genie": "🔮",
            "Timon": "🦁",
            "Pumbaa": "🐗"
        };
    }

    // Get emoji flag by country name
    getFlagByCountry(countryName) {
        // Use parseTextToKey to clean the country name
        const cleanCountryName = this.parseTextToKey(countryName);
    
        // Attempt direct lookup using the cleaned name
        const flag = this.flagsEmojiMappings[cleanCountryName];
    
        // Return the flag if found, or the white flag as a fallback
        return flag || "🏳️";
    }
    
    // Parse text to extract country and version
    parseTextToKey(text) {
        if (!text)
            return text;
    
        // Check and split by "(" to extract the part before parentheses
        if (text.includes("(")) {
            const parts = text.split("(");
            return parts[0].trim(); // Return the part before "("
        }
    
        // Check and split by "_" if "(" is not found
        if (text.includes("_")) {
            const parts = text.split("_");
            return parts[0].trim(); // Return the part before "_"
        }
    
        // If no special characters, return the trimmed text
        return text;
    }
}

export default new FlagsService();